/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import { ILdsStaplesMessageViewProps } from './lds-staples-message';
// import StaplesMessage from '../../helpers/utilities/staples-message';

export default (props: ILdsStaplesMessageViewProps) => {
    const [isVisible, setIsVisible] = React.useState(false);

    React.useEffect(() => {
        setIsVisible(props.context.request.user.isAuthenticated);
    }, []);

    let unitOrder = [];

    if (props.data.paymentTypes && props.data.paymentTypes.result) {
        unitOrder = props.data.paymentTypes.result.filter(payment => {
            return payment.ACCOUNTNUM !== '';
        });
    }
    // const message = StaplesMessage.filter(message => {
    //     return message.lang === 'en-us' && message.signedIn === false;
    // });
    // const signedInMessage = StaplesMessage.filter(message => {
    //     return message.lang === 'en-us' && message.signedIn === true;
    // });
    return (
        <div className='row'>
            <div dangerouslySetInnerHTML={{ __html: props.config.defaultStaplesMessage! }} />
            {isVisible && unitOrder.length !== 0 && <div dangerouslySetInnerHTML={{ __html: props.config.signedInStaplesMessage! }} />}
        </div>
    );
};
